module.exports = __webpack_public_path__ + "img/sygnali_logo_450.f15c393f.png";